import actionTypes from '../actions/actionTypes';

export default function(state = null, action = {}) {
    if (action.type === actionTypes.CHANGE_CARD_ID) {
        // Store the entire object with id and hashPan
        return action.id;
    } else {
        return state;
    }
}
